import React from 'react';
import { Grid, Form } from 'semantic-ui-react';
import { Field, reduxForm, formValueSelector } from 'redux-form';
import moment from 'moment';
import { connect } from 'react-redux';

import { CheckboxField, RangeDatePickerField } from 'Common/SemanticWrapper';
import { NC_SFS_4_FORM_NAME } from 'Common/FormEnum';
import { NCSFS4FieldEnum as Fields } from 'Common/FieldEnum';
import { rangeDateValidator } from 'Common/FormHelper';
import { SelectSitesTableReduxForm } from 'Common/SelectSitesTableReduxForm';
import { MONTH_YEAR_DATE_FORMAT } from 'Common/Constants';

const NCSFS4 = props => (
  <Form>
    <Grid>
      <Grid.Row>
        <Grid.Column width={8}>
          <RangeDatePickerField
            fromName={Fields.From}
            toName={Fields.To}
            fromDisabled={props.fiscalYearToDate}
            showMonthYearPicker
            dateFormat={MONTH_YEAR_DATE_FORMAT}
          />
        </Grid.Column>
      </Grid.Row>
    </Grid>
    <Field
      label="Fiscal Year to Date"
      name={Fields.FiscalYearToDate}
      component={CheckboxField}
      onChange={(e, value) => {
        if (value) {
          const from = moment(props.fiscalYearStart).format(
            MONTH_YEAR_DATE_FORMAT
          );
          props.change(Fields.From, from);
        }
      }}
    />
    <Field
      label="Summary Only"
      name={Fields.SummaryOnly}
      component={CheckboxField}
    />
    <Field
      label="Sites"
      name={Fields.Sites}
      component={SelectSitesTableReduxForm}
    />
  </Form>
);

const validate = values => {
  const errors = {};
  const rangeErrors = rangeDateValidator(
    values[Fields.From],
    values[Fields.To],
    {
      dateFormat: MONTH_YEAR_DATE_FORMAT,
      strict: true,
    }
  );

  if (!Array.isArray(values[Fields.Sites]) || values[Fields.Sites].length < 1) {
    errors[Fields.Sites] = 'Please select at least one site.';
  }

  return {
    ...errors,
    ...rangeErrors,
  };
};

const selector = formValueSelector(NC_SFS_4_FORM_NAME);
const mapStateToProps = state => ({
  fiscalYearToDate: selector(state, Fields.FiscalYearToDate),
});

const NCSFS4Form = connect(mapStateToProps)(
  reduxForm({
    form: NC_SFS_4_FORM_NAME,
    validate,
  })(NCSFS4)
);

export { NCSFS4Form };



// WEBPACK FOOTER //
// ./src/pages/ncsfs4/components/NCSFS4Form.js